<div *ngIf="!message && isLoading"><wl-busy [show]="isLoading"></wl-busy> {{ 'common.loading' | translate | titlecase }}</div>

<div *ngIf="!isLoading && message == null && requestedMessageId > 0">
  <p>{{ 'communications.mass-comm-message-edit.message-not-found' | translate | ucfirst }}</p>
</div>

<div *ngIf="message">
  <p *ngIf="hasNavigateBackRoute">
    <a (click)="handleNavigateBack()">{{ navigateBackText }}</a>
  </p>

  <div class="container-fluid form-horizontal highlight-box top-detail-box">
    <div *ngIf="!isLoading && message != null">
      <div class="row">
        <div class="col-sm-5 col-sm-push-7 col-lg-4 col-lg-push-8 text-right" *ngIf="userAccessLevel >= 2">
          <div class="mct-flex mct-row mct-justify-end mct-items-center mb-5 mct-gap-5">
            <button
              pButton
              type="button"
              [disabled]="gettingPreview"
              (click)="$event.preventDefault(); getMessagePreview()"
              class="atlas-btn atlas-btn-secondary"
              [icon]="!gettingPreview ? 'pi pi-eye' : ''"
            >
              <wl-busy [show]="gettingPreview"></wl-busy>
              {{ 'common.preview' | translate | titlecase }}
            </button>
            <button
              pButton
              type="button"
              class="atlas-btn atlas-btn-primary"
              [disabled]="userAccessLevel < 2 || isSaving || isLoading"
              (click)="saveClick()"
              *ngIf="!readonly || (isResend && (isScheduled ? !message.MessageSent : true))"
              icon="pi pi-save"
            >
              <wl-busy [show]="isSaving"></wl-busy>
              <span [hidden]="isSaving">{{
                (isResend
                  ? 'communications.mass-comm-message-edit.button-save-scheduled-message'
                  : 'communications.mass-comm-message-edit.save-draft'
                )
                  | translate
                  | titlecase
              }}</span>
              <span [hidden]="!isSaving">{{ 'common.saving' | translate | titlecase }}</span>
            </button>
          </div>
          <div class="mct-flex mct-row mct-justify-end mct-items-center mb-5 mct-gap-5">
            <button
              class="atlas-btn atlas-btn-danger"
              type="button"
              [hidden]="!message?.MessageId || readonly || isResend"
              (click)="confirmDeleteMessage()"
              [disabled]="userAccessLevel < 2 || isSaving || deleting"
              title="{{ 'common.delete' | translate | titlecase }}"
              style="background-color: #d90000; color: white"
            >
              <wl-busy [show]="deleting"></wl-busy>
              <i class="pi pi-trash" style="color: white; font-size: 1.1rem"></i>
              {{ 'common.delete' | translate | titlecase }}
            </button>
            <button
              pButton
              class="atlas-btn atlas-btn-secondary"
              type="button"
              [hidden]="!message?.MessageId || isResend"
              (click)="copyClick()"
              [disabled]="userAccessLevel < 2 || isSaving || deleting"
              title="{{ 'common.copy' | translate | titlecase }}"
              icon="pi pi-copy"
            >
              {{ 'common.copy' | translate | titlecase }}
            </button>
          </div>
        </div>
        <div class="col-sm-7 col-sm-pull-5 col-lg-8 col-lg-pull-4">
          <h2 *ngIf="message">
            {{ message?.Subject }} <span [hidden]="!message?.MessageId" class="small">({{ message?.MessageId }})</span>
          </h2>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="isLoading">
      <div class="col-xs-12">
        <div><wl-busy [show]="isLoading"></wl-busy> {{ 'common.loading' | translate | titlecase }}</div>
      </div>
    </div>
    <div class="row" *ngIf="!isLoading && message == null">
      <div class="col-xs-12">
        {{ 'communications.mass-comm-message-edit.message-not-found' | translate | ucfirst }}
      </div>
    </div>
  </div>

  <wlx-tabs #tabsContainer ng-hide="isLoading || message == null">
    <wlx-tab #massCommMessageTab [title]="'communications.mass-comm-message-edit.message-tab-title' | translate | titlecase">
      <ng-template wlLazyTabContent>
        <wl-mass-comm-message-edit-message
          [message]="message"
          [readonly]="readonly"
          [isResend]="isResend"
          [isScheduled]="isScheduled"
          (validChange)="massCommMessageTab.valid = $event"
        ></wl-mass-comm-message-edit-message>
      </ng-template>
    </wlx-tab>
    <wlx-tab #massCommProfilesTab [title]="'communications.mass-comm-message-edit.profiles-tab-title' | translate | titlecase">
      <wl-mass-comm-message-edit-profiles
        [message]="message"
        [readonly]="readonly"
        [isResend]="isResend"
        [isDraft]="isDraft || message?.MessageId <= 0"
        (validChange)="massCommProfilesTab.valid = $event"
      ></wl-mass-comm-message-edit-profiles>
    </wlx-tab>
    <wlx-tab [title]="'communications.mass-comm-message-edit.send-tab-title' | translate | titlecase" (selected)="handleSendTabSelected()">
      <wl-mass-comm-message-edit-send
        #sendComponent
        [message]="message"
        [flushMessageEditor]="flushMessageEditor"
        [readonly]="readonly"
        [isDraft]="isDraft || message?.MessageId <= 0"
        [isResend]="isResend"
        [userEmailAddress]="userEmailAddress"
      ></wl-mass-comm-message-edit-send>
    </wlx-tab>
    <wlx-tab
      [title]="'communications.mass-comm-message-edit.analytics-tab-title' | translate | titlecase"
      *ngIf="message && message.MessageId > 0 && !isDraft && !isResend"
    >
      <wl-mass-comm-message-edit-analytics [message]="message" [isDraft]="isDraft"></wl-mass-comm-message-edit-analytics>
    </wlx-tab>
  </wlx-tabs>

  <p-dialog
    #deleteEditMessageConfirmationModal
    modal="true"
    [(visible)]="showDeleteModal"
    [closable]="false"
    styleClass="atlas-dialog-s"
    [focusOnShow]="false"
    [contentStyle]="{ 'max-height': '75vh' }"
  >
    <p>{{ 'communications.mass-comm-message-admin.message-delete-confirmation-prompt' | translate }}</p>
    <ng-template pTemplate="footer">
      <wl-busy [show]="deleting"></wl-busy>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-danger"
        (click)="deleteMessgeConfirmed()"
        [disabled]="deleting"
        icon="pi pi-trash"
      >
        <span [hidden]="!deleting">
          {{ 'common.deleting' | translate | titlecase }}
        </span>
        <span [hidden]="deleting">
          {{ 'common.delete' | translate | titlecase }}
        </span>
      </button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-secondary"
        (click)="this.showDeleteModal = false"
        [disabled]="deleting"
        icon="pi pi-ban"
      >
        {{ 'common.cancel' | translate | titlecase }}
      </button>
    </ng-template>
  </p-dialog>

  <p-dialog
    #unsavedChangesModal
    modal="true"
    [(visible)]="showUnsavedModal"
    [closable]="false"
    styleClass="atlas-dialog-m"
    [focusOnShow]="false"
    [contentStyle]="{ 'max-height': '75vh' }"
  >
    {{ 'communications.mass-comm-message-edit.unsaved-changes-message' | translate }}
    <ng-template pTemplate="footer">
      <wl-busy *ngIf="isSaving" [show]="isSaving"></wl-busy>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary"
        [disabled]="isSaving"
        (click)="handleUnsavedChangesModalSaveClick()"
        icon="pi pi-save"
      >
        <span [hidden]="isSaving">{{ 'common.save' | translate | titlecase }}</span>
        <span [hidden]="!isSaving">{{ 'common.saving' | translate | titlecase }}</span>
      </button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-secondary"
        (click)="handleUnsavedChangesModalCancelClick()"
        [disabled]="isSaving"
        icon="pi pi-ban"
      >
        {{ 'common.cancel' | translate | titlecase }}
      </button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-default"
        (click)="handleUnsavedChangesModalNoClick()"
        [disabled]="isSaving"
        icon="pi pi-ban"
      >
        {{ 'common.no' | translate | titlecase }}
      </button>
    </ng-template>
  </p-dialog>

  <p-dialog
    #saveRecurringConfirmationModal
    modal="true"
    [(visible)]="showRecurringModal"
    [closable]="false"
    styleClass="atlas-dialog-m"
    [focusOnShow]="false"
    [contentStyle]="{ 'max-height': '75vh' }"
  >
    {{ 'communications.mass-comm-message-edit.mass-comm-send.send-recurring-email-prompt' | translate }}
    <ng-template pTemplate="footer">
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary"
        [disabled]="isSaving"
        (click)="handleRecurringModalYesClick()"
        icon="pi pi-save"
      >
        {{ 'communications.mass-comm-message-edit.mass-comm-send.schedule-email-button' | translate | titlecase }}
      </button>
      <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="handleRecurringModalCancelClick()" icon="pi pi-ban">
        {{ 'common.cancel' | translate | titlecase }}
      </button>
    </ng-template>
  </p-dialog>

  <p-dialog
    #invoiceEmailNotification
    modal="true"
    [(visible)]="showInvoiceEmailModal"
    [closable]="false"
    styleClass="atlas-dialog-m"
    [focusOnShow]="false"
    [contentStyle]="{ 'max-height': '75vh' }"
  >
    <ng-template pTemplate="header">
      {{ 'communications.mass-comm-message-edit.invoice-email-notification.title' | translate | titlecase }}
    </ng-template>
    <p>{{ 'communications.mass-comm-message-edit.invoice-email-notification.p1' | translate }}</p>
    <p>{{ 'communications.mass-comm-message-edit.invoice-email-notification.p2' | translate }}</p>
    <ng-template pTemplate="footer">
      <button type="button" class="atlas-btn atlas-btn-primary" (click)="showInvoiceEmailModal = false">
        {{ 'common.ok' | translate | titlecase }}
      </button>
    </ng-template>
  </p-dialog>
</div>
